<template>
    <div class="password-component" v-invalid="validation.is_valid">
    <div class="field" :class="getFieldClass(field.layout.layout_type)">
      <label class="label"
             v-if="field.label"
             :class="getLabelClass(field.layout.layout_type)"
             :for="field.id">
        <span>
          {{ field.label }}
        </span>
      </label>
      <div class="control" :class="getControlClass(field.layout.layout_type)">
        <input class="input"
               :class="getInputClass(validation.is_valid)"
               type="password"
               v-model="formData.fields[field.id].value"
               v-on:change="formData.inputOnChange(field)"
               v-on:keyup="removeValidation()"
               :id="field.id"
               :name="field.id"
               :placeholder="field.properties.placeholder_hint"
               :readonly="field.properties.input_readonly">

        <p class="help is-danger"
           v-if="!validation.is_valid">
          {{ validation.message }}
        </p>
        <p class="help"
           v-if="field.properties.help_text"
           v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'

  export default {
    name: 'password-component',
    props: {
      field: {
        type: FormField
      },
      formData: {
        type: FormData
      }
    },
    computed: {
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      }
    },
    methods: {
      removeValidation () {
        this.validation.is_valid = true
      },
      getFieldClass: function (layoutType) {
        return {
          'columns is-multiline is-mobile': layoutType === 'horizontal'
        }
      },
      getLabelClass: function (layoutType) {
        return {
          'column is-4': layoutType === 'horizontal'
        }
      },
      getControlClass: function (layoutType) {
        return {
          'column is-8': layoutType === 'horizontal'
        }
      },
      getInputClass: function (isValid) {
        return {
          'is-danger': !isValid
        }
      }
    }
  }
</script>
